import { DocumentStatus, DocumentType } from '@lombok/shared';
import type { BadgeTone } from '@lombok/ui';

/** Spanish labels for the customer-facing onboarding document types. */
export const DOC_TYPE_OPTIONS: { value: DocumentType; label: string }[] = [
  { value: DocumentType.RIF, label: 'RIF' },
  { value: DocumentType.LEGAL, label: 'Documento legal' },
  { value: DocumentType.AGREEMENT, label: 'Acuerdo / contrato' },
  { value: DocumentType.OTHER, label: 'Otro' },
];

const TYPE_LABELS: Record<string, string> = {
  [DocumentType.RIF]: 'RIF',
  [DocumentType.LEGAL]: 'Documento legal',
  [DocumentType.AGREEMENT]: 'Acuerdo / contrato',
  [DocumentType.PAYMENT_PROOF]: 'Comprobante de pago',
  [DocumentType.INVOICE_PDF]: 'Factura (PDF)',
  [DocumentType.PRODUCT_IMAGE]: 'Imagen de producto',
  [DocumentType.OTHER]: 'Otro',
};

export function documentTypeLabel(type: string): string {
  return TYPE_LABELS[type] ?? type;
}

export function documentStatusLabel(status: string): string {
  switch (status) {
    case DocumentStatus.PENDING:
      return 'En revisión';
    case DocumentStatus.APPROVED:
      return 'Aprobado';
    case DocumentStatus.REJECTED:
      return 'Rechazado';
    default:
      return status;
  }
}

export function documentStatusTone(status: string): BadgeTone {
  switch (status) {
    case DocumentStatus.APPROVED:
      return 'success';
    case DocumentStatus.REJECTED:
      return 'danger';
    case DocumentStatus.PENDING:
    default:
      return 'warning';
  }
}

/** File input `accept` + the exact content-type allowlist the backend honors. */
export const DOC_ACCEPT = 'image/png,image/jpeg,image/webp,application/pdf';
const ALLOWED = new Set(['image/png', 'image/jpeg', 'image/webp', 'application/pdf']);

export function isAllowedDocContentType(contentType: string | undefined | null): boolean {
  return Boolean(contentType && ALLOWED.has(contentType));
}
